<h3>Uw {{ productName }}</h3>
<table class="table-data table-data--polis" *ngIf="purchasedProduct">
    <colgroup>
        <col width="33%" />
        <col width="33%" />
        <col width="33%" />
    </colgroup>
    <tbody>
        <ng-container *ngIf="purchasedProduct?.product?.bicycle">
            <tr>
                <td>Merk</td>
                <td>
                    {{ purchasedProduct?.product?.bicycle?.bicycleBrand }}
                </td>
                <td></td>
            </tr>
            <tr>
                <td>Type fiets</td>
                <td>
                    {{ purchasedProduct?.product?.bicycle?.bicycleTypeDescription }}
                </td>
                <td></td>
            </tr>
            <tr>
                <td>Aanschaf datum</td>
                <td>
                    {{ purchasedProduct?.product?.bicycle?.purchaseDate | dateFormat }}
                </td>
                <td></td>
            </tr>
            <tr>
                <td>Aanschafwaarde</td>
                <td>€ {{ purchasedProduct?.product?.bicycle?.purchaseValueAmount | number: "1.2-2" }}</td>
                <td></td>
            </tr>
            <tr>
                <td>Fietssleutel nummer</td>
                <td>
                    {{ purchasedProduct?.product?.bicycle?.bicycleKeyNumber }}
                </td>
                <td></td>
            </tr>
            <tr>
                <td>Framenummer</td>
                <td>
                    {{ purchasedProduct?.product?.bicycle?.framenumber }}
                </td>
                <td></td>
            </tr>
        </ng-container>
    </tbody>
</table>
